import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import BKInput from './BKInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BKCurrencyInput',
  props: {
    value: { default: 0 },
    label: { default: '' },
    error: { type: Boolean, default: false },
    errorMessages: { default: () => [] },
    placeholder: { default: '' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rules: { default: () => [] },
    disabled: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    hideDetails: { type: [Boolean, String], default: 'auto' },
    color: { default: 'var(--color-blue-800)' },
    prefix: { default: '$' }
  },
  emits: ["blur", "focus", "input", "keyup", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'blur'): void
  (e: 'focus'): void
  (e: 'input', value: number): void
  (e: 'keyup', value: KeyboardEvent): void
  (e: 'update:modelValue', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number, label: string, error: boolean, errorMessages: string | string[], placeholder: string, readonly: boolean, required: boolean, rules: ((value: string | number | undefined) => unknown)[], disabled: boolean, dense: boolean, hideDetails: boolean | 'auto', color: string, prefix: string };





// Internal value initialized only on mount
const internalValue = ref('')

// Initialize internal value only on mount
onMounted(() => {
  internalValue.value = (props.value / 100).toFixed(2)
})

function handleInput(value: string | number) {
  if (typeof value === 'string') {
    if (value.trim() === '') {
      const centsValue = 0
      emit('input', centsValue)
      emit('update:modelValue', centsValue)
      return
    }

    const numericValue = parseFloat(value) * 100

    if (Number.isNaN(numericValue)) {
      const centsValue = 0
      emit('input', centsValue)
      emit('update:modelValue', centsValue)
      return
    }

    const centsValue = Math.max(0, Math.round(numericValue))
    emit('input', centsValue)
    emit('update:modelValue', centsValue)
  } else {
    const centsValue = Math.max(0, Math.round(value * 100 || 0))
    emit('input', centsValue)
    emit('update:modelValue', centsValue)
  }
}

return { __sfc: true,emit, props, internalValue, handleInput, BKInput }
}

})